<template>
    <div class="main-sectio-wrapper">
        <router-view :key="this.$route.fullPath" />
    </div>
</template>
<script>
export default {
    name: '',
}
</script>